import React, { useState } from 'react';
import { Plus, Ticket, CheckCircle2 } from 'lucide-react';
import { Modal } from './ui/Modal';
import { Input } from './ui/Input';
import { Select } from './ui/Select';
import { Textarea } from './ui/Textarea';
import { Button } from './ui/Button';
import { useNotifications } from '../contexts/NotificationContext';
import { motion, AnimatePresence } from 'framer-motion';
export function QuickTicket() {
  const [isOpen, setIsOpen] = useState(false);
  const [saveSuccess, setSaveSuccess] = useState(false);
  const {
    addNotification
  } = useNotifications();
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSaveSuccess(true);
    setTimeout(() => {
      setSaveSuccess(false);
      setIsOpen(false);
      addNotification('success', 'Ticket creato', 'Il ticket è stato aperto con successo');
    }, 1500);
  };
  return <>
      <button onClick={() => setIsOpen(true)} className="fixed bottom-8 right-8 z-40 bg-seform-orange text-white p-4 rounded-full shadow-lg hover:bg-orange-600 hover:scale-105 transition-all duration-200 group" title="Nuovo Ticket Rapido" data-id="element-314">
        <Plus className="h-6 w-6 group-hover:rotate-90 transition-transform duration-300" data-id="element-315" />
      </button>

      <Modal isOpen={isOpen} onClose={() => {
      setIsOpen(false);
      setSaveSuccess(false);
    }} title="Nuovo Ticket Rapido" size="lg" data-id="element-316">
        <AnimatePresence mode="wait" data-id="element-317">
          {saveSuccess ? <motion.div key="success" initial={{
          opacity: 0,
          scale: 0.8
        }} animate={{
          opacity: 1,
          scale: 1
        }} className="flex flex-col items-center justify-center py-16" data-id="element-318">
              <motion.div initial={{
            scale: 0
          }} animate={{
            scale: 1
          }} transition={{
            type: 'spring',
            stiffness: 200,
            damping: 15
          }} className="w-20 h-20 rounded-full bg-green-100 flex items-center justify-center mb-4" data-id="element-319">
                <CheckCircle2 className="w-12 h-12 text-green-500" data-id="element-320" />
              </motion.div>
              <p className="text-lg font-semibold text-slate-800" data-id="element-321">
                Ticket creato con successo
              </p>
            </motion.div> : <motion.div key="form" initial={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} data-id="element-322">
              <form onSubmit={handleSubmit} className="space-y-6" data-id="element-323">
                <div className="bg-blue-50 p-4 rounded-xl border border-blue-100 flex items-start gap-3" data-id="element-324">
                  <Ticket className="h-5 w-5 text-blue-600 mt-0.5" data-id="element-325" />
                  <div data-id="element-326">
                    <p className="text-sm text-blue-800 font-medium" data-id="element-327">
                      Apertura Ticket Interno
                    </p>
                    <p className="text-xs text-blue-600 mt-1" data-id="element-328">
                      Usa questo modulo per segnalare problemi o richieste
                      rapide da qualsiasi pagina.
                    </p>
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-329">
                  <Select label="Tipologia" options={[{
                value: 'bug',
                label: 'Errore Software'
              }, {
                value: 'feature',
                label: 'Richiesta Funzionalità'
              }, {
                value: 'support',
                label: 'Assistenza Tecnica'
              }, {
                value: 'admin',
                label: 'Amministrativo'
              }]} required data-id="element-330" />
                  <Select label="Priorità" options={[{
                value: 'standard',
                label: 'Standard'
              }, {
                value: 'urgent',
                label: 'Urgente'
              }]} required data-id="element-331" />
                  <Input label="Azienda (opzionale)" placeholder="Cerca cliente..." className="col-span-full" data-id="element-332" />
                  <Textarea label="Descrizione" placeholder="Descrivi il problema..." required className="col-span-full" data-id="element-333" />
                  <Select label="Assegnato a" options={[{
                value: 'alessio',
                label: 'Alessio'
              }, {
                value: 'lorenzo',
                label: 'Lorenzo'
              }, {
                value: 'dev',
                label: 'Team Sviluppo'
              }, {
                value: 'admin',
                label: 'Amministrazione'
              }]} data-id="element-334" />
                  <Input label="Scadenza" type="date" data-id="element-335" />
                </div>

                <div className="flex justify-end gap-3 pt-4 border-t border-slate-100" data-id="element-336">
                  <Button type="button" variant="flat" onClick={() => setIsOpen(false)} data-id="element-337">
                    Annulla
                  </Button>
                  <Button type="submit" data-id="element-338">Crea Ticket</Button>
                </div>
              </form>
            </motion.div>}
        </AnimatePresence>
      </Modal>
    </>;
}